module.exports = __webpack_public_path__ + "img/Screenshot_PATLY.5cb854c7.svg";